module.exports = __webpack_public_path__ + "img/kitActivo.eb901662.svg";